import { defineComponent } from "vue";

import { COMPONENT_NAME } from "./attributes";

import { SharedWindow } from "@/components/shared";

import { SharedSelect } from "@/components/shared";
import { UIInput, UIButton } from "@/components/ui";

import { SelectOptionFactory } from "@/shared/factory/select";
import { SharedSelectOption } from "@/components/shared/select/model";
import { WalletModalFactory } from "@/shared/repository/modules/wallet/factory";
import { AdminApplicationType } from "@/shared/repository/modules/admin/application/enums";
import {
  AdminCurrencyShowResponse,
  AdminChainListResponse,
} from "@/shared/repository/modules/admin/currency/repo";

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    SharedWindow,
    SharedSelect,
    UIInput,
    UIButton,
  },
  data() {
    return {
      walletRepository: this.$projectServices.walletRepository,
      walletRepo: this.$projectServices.walletRepo,
      toast: this.$toast,
      coinId: 0,
      chain: "",
      address: { addressDeposit: "", tagDeposit: "" },
      currencys: <AdminCurrencyShowResponse[]>[],
      chains: <AdminChainListResponse[]>[],
    };
  },
  async created(): Promise<void> {
    this.currencys = await this.walletRepository.currency();
    if (this.walletRepo.modal.currencyId) {
      this.coinId = this.walletRepo.modal.currencyId;
      await this.loadChains();
    }
  },
  computed: {
    displayedCurrencyOptions(): SharedSelectOption[] {
      return this.currencys
        .filter(
          (currency) => currency.type === "crypto" && currency.frozen === false
        )
        .map((currency) =>
          SelectOptionFactory({
            id: currency.id,
            label: currency.name.toUpperCase(),
            value: currency.id,
            icon: currency.name.toLowerCase(),
            isActive: false,
          })
        );
    },

    displayedChainOptions(): SharedSelectOption[] {
      return this.chains.map((chain) =>
        SelectOptionFactory({
          label:
            chain.chain +
            " (Min: " +
            chain.withdrawMin +
            " Fee: " +
            chain.withdrawFee +
            ")",
          value: chain.chain,
          isActive: false,
        })
      );
    },

    displayedCurrencyIcon(): string {
      return (
        this.currencys.find((currency) => currency.id === this.coinId)?.name ??
        ""
      );
    },
  },
  methods: {
    handleClose(): void {
      this.walletRepo.UPDATE_MODAL(WalletModalFactory());
    },

    openFiatDeposit(): void {
      this.walletRepo.UPDATE_MODAL(
        WalletModalFactory({ type: AdminApplicationType.deposit })
      );
    },

    async loadChains(): Promise<void> {
      this.address = { addressDeposit: "", tagDeposit: "" };
      this.chain = "";
      this.chains = [];
      try {
        this.chains = await this.walletRepository.chains(this.coinId);
      } catch (error) {
        console.log("loadChains", error);
      }
    },

    async getDepositAddress(): Promise<void> {
      const currency = this.currencys.find(
        (currency) => currency.id === this.coinId
      );
      if (currency && this.chain) {
        try {
          const address = await this.walletRepository.deposit(
            currency?.name,
            this.chain
          );
          this.address.addressDeposit = address?.addressDeposit || "";
          this.address.tagDeposit = address?.tagDeposit || "";
        } catch (e) {
          this.address.addressDeposit = "";
          this.address.tagDeposit = "";
          console.log(e);
        }
      }
    },

    copyAddressToCliboard(): void {
      if (this.address.addressDeposit) {
        navigator.clipboard.writeText(this.address.addressDeposit);
      }
    },

    copyTagToCliboard(): void {
      if (this.address.tagDeposit) {
        navigator.clipboard.writeText(this.address.tagDeposit);
      }
    },
  },
});
